import "./css/output.css";
export default function BooleanValue({ label, value, className, ...props }) {
  const computedClassName = ["output", "boolean-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>&nbsp;
        </>
      )}
      <span>{value === true ? "Sí" : "No"}</span>
    </div>
  );
}

BooleanValue.defaultProps = {
  className: "",
};
